import Joi from 'joi';

/**
 * Schema for renter user-app settings updates.
 */
export const updateProtoUserAppSettingsSchema = () =>
  Joi.object({
    settingsValues: Joi.object().unknown(true).required().messages({
      'any.required': 'validations|user-app-settings-values|required',
      'object.base': 'validations|user-app-settings-values|must-be-object',
    }),
  }).unknown();
